module.exports = __webpack_public_path__ + "static/media/IMG_8045.146f4424.jpg";